module.exports = __webpack_public_path__ + "static/media/search@2x.6c5f08a1.svg";